import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';

import { getNotificationBadge, getNotificationFeed } from './api';

import type { AxiosInstance } from 'axios';
import type { NotificationCategory } from '../../constants/types/notification';

/**
 * Notification feed/badge Query Factory.
 * @description
 * - feed: cursor pagination (10개씩, 최대 100페이지=1000개)
 * - badge: GNB bell에 표시되는 unseenCount
 * @description
 * - `category`를 지정하면 탭별(리소스/콘솔 새소식) 독립 query로 분리된다 (queryKey에 포함).
 */
export const notificationQueries = {
  all: () => ['notifications'] as const,

  feed: (instance: AxiosInstance, limit = 10, category?: NotificationCategory) =>
    infiniteQueryOptions({
      queryKey: [...notificationQueries.all(), 'feed', { limit, category }] as const,
      queryFn: ({ pageParam, signal }) =>
        getNotificationFeed(instance, { cursor: pageParam, limit, category }, signal),
      initialPageParam: undefined as string | undefined,
      getNextPageParam: last => (last.hasMore ? (last.nextCursor ?? undefined) : undefined),
      maxPages: 100,
    }),

  badge: (instance: AxiosInstance) =>
    queryOptions({
      queryKey: [...notificationQueries.all(), 'badge'] as const,
      queryFn: ({ signal }) => getNotificationBadge(instance, signal),
    }),
};
